import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { EmailProviderCheck } from "@/components/settings/EmailProviderCheck";
import { EMAIL_SENDERS_HELP_PATH } from "@/lib/email/detect-provider";

/** Public (no login) page: /tools/email-check. */
export function EmailCheckPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Is my email Google or Microsoft?</CardTitle>
          <CardDescription>
            Enter your work email. We check who handles its mail, so you know which button to
            use in Built It: Connect Gmail or Connect Outlook.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <EmailProviderCheck />
          <p className="text-xs text-muted-foreground">
            We only look up your email's domain, using a public DNS service. We don't store your address.
          </p>
          <div className="flex flex-wrap items-center gap-3 border-t pt-4">
            <Button asChild>
              <Link to="/login">Sign in to Built It</Link>
            </Button>
            <Link
              to={EMAIL_SENDERS_HELP_PATH}
              className="text-sm underline underline-offset-2"
            >
              Help: managing email senders
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
